import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { MediaBaseRouteDelete } from "./media";
import { cfAPI } from "../api";
import { createProgressHandler } from "../utils/createProgressHandler"; // Assuming this is correct

const VIDEO_REQUEST = "VIDEO_REQUEST";
const VIDEO_ERROR = "VIDEO_ERROR";
const VIDEOS_FETCH = "VIDEOS_FETCH";
const VIDEO_FETCH = "VIDEO_FETCH";
const VIDEO_CREATE = "VIDEO_CREATE";
const VIDEO_EDIT = "VIDEO_EDIT";
const VIDEO_DELETE = "VIDEO_DELETE";
const VIDEO_REORDER_LOCAL = "VIDEO_REORDER_LOCAL";

const VIDEO_DOWNLOAD_START = "VIDEO_DOWNLOAD_START";
const VIDEO_DOWNLOAD_UPDATE = "VIDEO_DOWNLOAD_UPDATE";
const VIDEO_DOWNLOAD_FINISH = "VIDEO_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/videos";

const INITIAL_STATE = {
  loading: false,
  videos: [],
  video: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

const actionTypes = {
  create: { request: VIDEO_REQUEST, success: VIDEO_CREATE, error: VIDEO_ERROR },
  update: { request: VIDEO_REQUEST, success: VIDEO_EDIT, error: VIDEO_ERROR },
  delete: { request: VIDEO_REQUEST, success: VIDEO_DELETE, error: VIDEO_ERROR },
};

const videoProgressActionTypes = {
  request: VIDEO_REQUEST,
  start: VIDEO_DOWNLOAD_START,
  update: VIDEO_DOWNLOAD_UPDATE,
  finish: VIDEO_DOWNLOAD_FINISH,
  success: VIDEOS_FETCH,
  error: VIDEO_ERROR,
};

export const CreateVideo = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, values),
    actionTypes.create,
    "Video Created"
  );
};

export const FetchVideos = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          videoProgressActionTypes.update,
          videoProgressActionTypes.finish
        ),
      }),
    videoProgressActionTypes,
    createProgressHandler
  );
};

export const FetchVideo = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    { request: VIDEO_REQUEST, success: VIDEO_FETCH, error: VIDEO_ERROR },
    null // No toast message for fetching a single video
  );
};

export const UpdateVideo = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, values),
    actionTypes.update,
    "Video Updated"
  );
};

export const DeleteGalleryPicture = (name, fileName) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(MediaBaseRouteDelete(name, fileName)),
    actionTypes.deleteImage,
    "Image Deleted"
  );
};

export const DeleteVideo = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Video Deleted!"
  );
};

export const ReorderedVideos = (reorderedVideo) => async (dispatch) => {
  dispatch({
    type: VIDEO_REORDER_LOCAL,
    payload: reorderedVideo,
  });

  // Create the payload for the backend
  const reorderPayload = reorderedVideo.map((item, index) => ({
    id: item.id,
    sortOrder: index,
  }));

  try {
    // Call the backend API to save the new order
    await cfAPI.post(`${BaseRoute}/reorder`, reorderPayload);
  } catch (error) {
    // If the API call fails, dispatch an error and potentially revert the state
    dispatch({
      type: VIDEO_ERROR,
      payload: "Failed to save the new order.",
    });
    dispatch(FetchVideos());
  }
};
export const VideoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VIDEO_DOWNLOAD_START:
      return {
        ...state,
        isDownloading: true,
        downloadProgress: 0,
      };
    case VIDEO_DOWNLOAD_UPDATE:
      return {
        ...state,
        downloadProgress: action.payload,
      };
    case VIDEO_DOWNLOAD_FINISH:
      return {
        ...state,
        isDownloading: false,
        downloadProgress: 100,
      };
    case VIDEO_REQUEST:
      return { ...state, loading: true };
    case VIDEOS_FETCH:
      return {
        ...state,
        loading: false,
        error: "",
        videos: action.payload,
      };
    case VIDEO_FETCH:
      return {
        ...state,
        loading: false,
        error: "",
        video: action.payload,
      };
    case VIDEO_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        videos: [...state.videos, action.payload],
      };
    case VIDEO_EDIT:
      return {
        ...state,
        loading: false,
        error: "",
        video: action.payload,
        videos: state.videos.map((v) =>
          v.id === action.payload.id ? action.payload : v
        ),
      };
    case VIDEO_DELETE:
      const newList = state.videos.filter((s) => s.id !== action.payload.id);
      return {
        ...state,
        loading: false,
        error: "",
        videos: newList,
      };
    case VIDEO_REORDER_LOCAL:
      return {
        ...state,
        videos: action.payload,
      };
    case VIDEO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
